module.exports = __webpack_public_path__ + "img/files.dd8f59b6.svg";